import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <span className="brand">مؤسسة نبض المستقبل</span>
        <span className="copy">© جميع الحقوق محفوظة</span>
      </div>
    </footer>
  )
}

export default Footer
